import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

const FieldError = styled.span`
  color: ${tokens.colors.error};
  font-size: ${tokens.fontSizes.xs};
  font-family: ${tokens.font.family.ifood.body};
  margin: ${tokens.space.smallest} ${tokens.space.smaller};
  display: block;
`;

export default FieldError;
